var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.5H2.33333C1.97971 1.5 1.64057 1.64048 1.39052 1.89052C1.14048 2.14057 1 2.47971 1 2.83333V12.1667C1 12.5203 1.14048 12.8594 1.39052 13.1095C1.64057 13.3595 1.97971 13.5 2.33333 13.5H11.6667C12.0203 13.5 12.3594 13.3595 12.6095 13.1095C12.8595 12.8594 13 12.5203 13 12.1667V7.5",
    stroke: "#007FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2475 1.25003C11.5127 0.984812 11.8724 0.835815 12.2475 0.835815C12.6225 0.835815 12.9822 0.984812 13.2475 1.25003C13.5127 1.51525 13.6617 1.87496 13.6617 2.25003C13.6617 2.6251 13.5127 2.98481 13.2475 3.25003L7.23879 9.25937C7.08049 9.41753 6.88493 9.53331 6.67013 9.59603L4.75479 10.156C4.69743 10.1728 4.63662 10.1738 4.57873 10.1589C4.52084 10.1441 4.46801 10.114 4.42576 10.0717C4.3835 10.0295 4.35338 9.97664 4.33855 9.91876C4.32372 9.86087 4.32473 9.80006 4.34146 9.7427L4.90146 7.82736C4.96448 7.61273 5.08048 7.4174 5.23879 7.25936L11.2475 1.25003Z",
    stroke: "#007FFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c1f75725d7e512e048a75534e9263059.svg";
export { ForwardRef as ReactComponent };